import { versionedResourceWithPagination } from './utils';

const RESOURCE_NAME = 'books';

export default function booksRoutes(context) {
  versionedResourceWithPagination(context, { resource: RESOURCE_NAME });
}
